import React from 'react';
import '../styles/InteractiveHoverButton.css';

function InteractiveHoverButton({ text = "Button", href, onClick, className = "" }) {
    const handleClick = (e) => {
        if (href) {
            window.open(href, '_blank', 'noopener,noreferrer');
        }
        if (onClick) {
            onClick(e);
        }
    };

    return (
        <button
            className={`interactive-hover-btn ${className}`}
            onClick={handleClick}
        >
            <span className="btn-text">{text}</span>
            <div className="btn-hover-content">
                <span>{text}</span>
                <svg
                    className="arrow-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>
            </div>
            <div className="btn-bg-circle"></div>
        </button>
    );
}

export default InteractiveHoverButton;
